import { schemaId } from '../fixture-ids';

export const schemaEntries = {
  SCHEMA_CREATED: {
    entity: 'schema',
    identity: 'record',
    idKeys: ['schemaId'],
    renderMode: 'diff',
    createsRecord: true,
    foreignDisplayKeys: ['name', 'description'],
    complexKeys: ['jsonSchema'],
  },
  SCHEMA_UPDATED: {
    entity: 'schema',
    identity: 'record',
    idKeys: ['schemaId'],
    renderMode: 'diff',
    createsRecord: false,
    foreignDisplayKeys: ['name', 'description'],
    complexKeys: ['jsonSchema'],
  },
  // schemas_audit_log (trigger ON schemas, not schema_versions) supplies name/description from
  // NEW directly here -- only jsonSchema is a foreign lookup (latest schema_versions row by
  // version DESC), unlike CREATED/UPDATED where name/description are the foreign fields instead.
  SCHEMA_DELETED: {
    entity: 'schema',
    identity: 'record',
    idKeys: ['schemaId'],
    renderMode: 'diff',
    createsRecord: false,
    foreignDisplayKeys: ['jsonSchema'],
    complexKeys: ['jsonSchema'],
  },
};

export const schemaFixtures = {
  SCHEMA_CREATED: {
    action: 'SCHEMA_CREATED',
    debugData: {
      schemaId,
      name: 'Checkout Completed',
      description: 'Schema for checkout completion events',
      jsonSchema: { type: 'object', required: ['orderId'], properties: { orderId: { type: 'string' } } },
      version: 1,
    },
  },
  SCHEMA_UPDATED: {
    action: 'SCHEMA_UPDATED',
    debugData: {
      schemaId,
      name: 'Checkout Completed',
      description: 'Schema for checkout completion events, v2 adds total',
      jsonSchema: {
        type: 'object',
        required: ['orderId', 'total'],
        properties: { orderId: { type: 'string' }, total: { type: 'number' } },
      },
      version: 2,
    },
  },
  SCHEMA_DELETED: {
    action: 'SCHEMA_DELETED',
    debugData: {
      schemaId,
      name: 'Checkout Completed',
      description: 'Schema for checkout completion events, v2 adds total',
      jsonSchema: {
        type: 'object',
        required: ['orderId', 'total'],
        properties: { orderId: { type: 'string' }, total: { type: 'number' } },
      },
    },
  },
};
